module.exports = __webpack_public_path__ + "img/templates.9095fc7f.svg";